import React from "react";
import { Controller } from "react-hook-form";
import { PhoneComponent } from "./PhoneComponent";
import { WcTextFieldProps } from "@bpipartners/webui";

type PhoneControllerProps = WcTextFieldProps & {
  control: any;
  name: string;
};
export const PhoneController = ({ control, name, ...rest }: PhoneControllerProps) => (
  <Controller
    name={name}
    control={control}
    render={({ field: { onChange, value } }) => <PhoneComponent {...rest} value={value} onCustomChange={onChange} />}
  />
);
